class TableDto {
    constructor() {
        this.filter = null;
        this.order = null;
        this.paging = null;
        this.query = null;
    }
}

export default TableDto;

export class Paging {
    constructor(start, limit) {
        this.start = start;
        this.limit = limit;
    }
}

export class Order {
    constructor(propertyName, ascending, isAllSolutions) {
        this.ascending = ascending;
        this.propertyName = propertyName;
        this.isAllSolutions= isAllSolutions;
    }
}